import urlParse from 'url-parse';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Request } from 'express'; // This is a type, not code

export * from './constants.common';

declare const _IMAGES_URL: string;
declare const _REALTIME_ORIGIN: string;
declare const _DEBUG: boolean;
declare const _SSR: boolean;
declare const _PLATFORM: 'web' | 'mobile';

export const DEBUG = _DEBUG;
export const SSR = _SSR;

export const IMAGES_URL = _IMAGES_URL;

export const PLATFORM = _PLATFORM;

export const getOrigin = (req: Request): string => {
  /**
   * WARNING: clients can send anything they want for the X-Blah-Blah
   * headers unless there is a proxy overwriting them!
   */
  // Why does express request not have a port?
  let clientPort: string;
  const header = req.headers['x-forwarded-port'];
  if (header) {
    if (typeof header === 'string') {
      clientPort = header;
    } else {
      clientPort = header[0];
    }
  } else if (req.headers.host && req.headers.host.indexOf(':') !== -1) {
    clientPort = req.headers.host.split(':')[1];
  } else {
    clientPort = req.protocol === 'https' ? '443' : '80';
  }
  const parsedUrl = urlParse(`${req.protocol}://${req.hostname}:${clientPort}`);
  return parsedUrl.origin;
};

const parsedRealTimeOrigin = urlParse(_REALTIME_ORIGIN);

export const REALTIME_SECURE = parsedRealTimeOrigin.protocol === 'wss:';
export const REALTIME_HOSTNAME = parsedRealTimeOrigin.hostname;
export const REALTIME_PORT =
  Number(parsedRealTimeOrigin.port) || (REALTIME_SECURE ? 443 : 80);
